/**
 * Where the bundle came from is where its config lives.
 *
 * The base is derived from the running script's own src rather than compiled in, so the same file
 * works from the production CDN, from a staging distribution and from a publisher's own mirror.
 */

/** Everything up to and including the directory the script sits in, with no trailing slash. */
export function cdnBaseFromSrc(src: string, pageUrl?: string): string {
  // Without a src there is nothing to derive from: resolving an empty string against the page
  // would silently point config lookups at the publisher's own origin.
  if (src.length === 0) return '';

  let url: URL;
  try {
    url = pageUrl === undefined ? new URL(src) : new URL(src, pageUrl);
  } catch {
    return '';
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';

  url.search = '';
  url.hash = '';
  const path = url.pathname;
  const lastSlash = path.lastIndexOf('/');
  url.pathname = lastSlash <= 0 ? '/' : path.slice(0, lastSlash);

  const out = url.toString();
  return out.endsWith('/') ? out.slice(0, -1) : out;
}

/** The pointer document, matching `publishedPointerKey` in @quizee/core. */
export function configUrl(cdnBase: string, interactionId: string): string {
  return `${cdnBase}/i/${interactionId}/live.json`;
}
